import React, { memo, useEffect } from "react";
import { TransactionMessage } from "../../../../app/data/transaction-monitor/models";
import { useDispatch, useSelector } from "react-redux";
import { TransactionMessageDumpState } from "../../../../slices/transaction-monitor/transaction-messages/TransactionMessagesState";
import Loading from "../../../../ui-components/loading/loading";
import { getTransactionMessageDump, transactionMessageDumpSelector } from "../../../../slices/transaction-monitor/transaction-messages/transactionMessageDumpSlice";

export interface TransactionMessageDataProps {
    transactionMessage: TransactionMessage
}

const TransactionMessageData: React.FC<TransactionMessageDataProps> = memo((props) => {
    const dispatch = useDispatch();
    const transactionMessageDumpState: TransactionMessageDumpState = useSelector(transactionMessageDumpSelector);

    useEffect(()=>{
        if(!transactionMessageDumpState.loading){
            dispatch(getTransactionMessageDump(props.transactionMessage.id))
        }
         // eslint-disable-next-line
    }, [props?.transactionMessage?.id])

    const formatXml = (xml: string)=> {
        const PADDING = ' '.repeat(4); 
        const reg = /(>)(<)(\/*)/g;
        let formatted = '';
        let pad = 0;
        
        xml = xml.replace(reg, '$1\r\n$2$3');
        xml.split('\r\n').forEach((node) => {
          let indent = 0;
          if (node.match(/.+<\/\w[^>]*>$/)) {
            indent = 0;
          } else if (node.match(/^<\/\w/)) {
            if (pad !== 0) pad -= 1;
          } else if (node.match(/^<\w([^>]*[^/])?>.*$/)) {
            indent = 1;
          } else {
            indent = 0;
          }
          formatted += PADDING.repeat(pad) + node + '\r\n';
          pad += indent;
        });
        
        return formatted.trim();
      }

    const getFormattedMessageData = (rawData: string | null, messageDataFormat: string | null): string =>{
        try{
            if(!rawData) return "No data available";
            if(!messageDataFormat) return rawData;
            if(messageDataFormat.toUpperCase() === "JSON" ){
                return JSON.stringify(JSON.parse(rawData), null, 4);
            }else if(messageDataFormat.toUpperCase() === "JSON"){
                return formatXml(rawData);
            }else{
                return rawData;
            }
        }catch(error){
            return (rawData) ? rawData : "No data available" ;
        }
    }
    return (
       <div className="message-data">
        <pre>{
            (transactionMessageDumpState.loading) ? <Loading isLoading={true}></Loading>
            : getFormattedMessageData(transactionMessageDumpState.messageData, transactionMessageDumpState.messageDataFormat)
        }</pre>
       </div>
    );
});

export default TransactionMessageData;
